/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { styled } from "@mui/material";

export const SideContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  margin: "1rem",
  [theme.breakpoints.down("sm")]: {
    margin: "0",
  },
}));
